var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendeProfile2User(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18088 9.07646C8.09916 9.06829 8.0011 9.06829 7.91121 9.07646C5.96633 9.01109 4.42188 7.4176 4.42188 5.45638C4.42187 3.4543 6.03988 1.82812 8.05013 1.82812C10.0522 1.82812 11.6784 3.4543 11.6784 5.45638C11.6702 7.4176 10.1258 9.01109 8.18088 9.07646Z",
    stroke: "#248BBF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1062 3.4624C15.6916 3.4624 16.9663 4.74537 16.9663 6.32251C16.9663 7.86697 15.7406 9.12542 14.2125 9.18262C14.1471 9.17445 14.0735 9.17445 14 9.18262",
    stroke: "#248BBF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09645 12.0918C2.11889 13.4156 2.11889 15.573 4.09645 16.8886C6.34368 18.3922 10.0291 18.3922 12.2764 16.8886C14.2539 15.5648 14.2539 13.4074 12.2764 12.0918C10.0373 10.5964 6.35185 10.5964 4.09645 12.0918Z",
    stroke: "#248BBF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6836 16.5373C16.272 16.4147 16.8276 16.1778 17.2853 15.8264C18.56 14.8703 18.56 13.2931 17.2853 12.337C16.8358 11.9938 16.2883 11.765 15.7081 11.6343",
    stroke: "#248BBF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendeProfile2User);
export default __webpack_public_path__ + "static/media/attende-profile-2user.164f527276a93cdca840754f3f20023b.svg";
export { ForwardRef as ReactComponent };